import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopCarouselComponent } from './shop-carousels.component';
import { CsIconModule } from '@components/icon';

@NgModule({
  imports: [CommonModule, CsIconModule],
  declarations: [ShopCarouselComponent],
  exports: [ShopCarouselComponent],
})
export class ShopCarouselsModule {}
